import { useTeacherStudentUserQuery } from './schema'

export const useStudentUserId = (): string | undefined => {
  const { data } = useTeacherStudentUserQuery()
  return data?.viewer?.teacher?.studentUser?.id
}
